import React from "react";

const GetInTouch = ({ heading, message, email }) => {
  return (
    <>
      <h2 className="section-heading pb-3">{heading}</h2>
      <p className="lead pb-3">
        {message} <a className="text-link" href={`mailto:${email}`}>{email}</a>
      </p>
    </>
  );
};

export default GetInTouch;
